/* ============================================================
   CANDELINAS CUSTOM: Melomakarono seasonal landing page (lp-melo-*)
   Loaded by snippets/lp-melo-assets.liquid, alongside lp.js.

   Division of labour with lp.js, which is LIVE for the Mystery Box pages:
   - lp.js owns the cart. The hero renders the page's one [data-lp-form]; its submit
     handler posts /cart/add.js and opens the native quick-cart. Nothing here duplicates
     that, and nothing here binds in the capture phase.
   - this file owns the tier state: it writes the form's quantity input and repaints the
     price labels (including the shared sticky bar's, through lp.js's own data hooks).
   - the bundle button is the one cart action lp.js cannot do, because it adds TWO
     different variants in one go, so it posts its own /cart/add.js.

   Every figure printed here is computed from the variant price in the markup and the
   same percentages the Shopify automatic discount applies, so the page cannot show a
   total the cart will refuse.
   ============================================================ */
(function () {
  'use strict';
  if (window.__cdlMeloInit) return;
  window.__cdlMeloInit = true;

  var ROOT = '[data-melo-root]';

  /* Comma decimal, trailing symbol: "8,50€". Cents always shown, so a tier never reads
     "34€" next to "36,13€". */
  function eur(cents) {
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + '€';
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  var S = { root: null, unit: 0, tiers: [], i: 0 };

  function readTiers(root) {
    return qsa('[data-melo-tier]', root).map(function (el) {
      var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
      var pct = parseFloat(el.getAttribute('data-discount')) || 0;
      var full = S.unit * qty;
      return {
        el: el,
        qty: qty,
        pct: pct,
        full: full,
        /* A per-bar discount wins over everything: the automatic discounts are a fixed
           amount off each bar, and deriving the total from the live unit price is what
           keeps /en-eu honest — there the bar is 11,05€, not 8,50€. */
        price: (function () {
          var off = parseInt(el.getAttribute('data-unit-off'), 10) || 0;
          if (off > 0) return Math.max(0, (S.unit - off)) * qty;
          return el.hasAttribute('data-price')
            ? (parseInt(el.getAttribute('data-price'), 10) || Math.round(full * (100 - pct) / 100))
            : Math.round(full * (100 - pct) / 100);
        })(),
        label: el.getAttribute('data-label') || ''
      };
    });
  }

  function paint() {
    var t = S.tiers[S.i];
    if (!t) return;
    var save = Math.max(0, t.full - t.price);

    S.tiers.forEach(function (x, i) {
      x.el.classList.toggle('is-on', i === S.i);
      x.el.setAttribute('aria-pressed', i === S.i ? 'true' : 'false');
    });

    // the form is the quantity: one variant, N bars
    var form = document.querySelector('[data-lp-form]');
    if (form) {
      var q = form.querySelector('[name="quantity"]');
      if (q) q.value = String(t.qty);
    }

    // lp.js's own hooks, so the shared sticky bar follows without being edited
    var prefix = S.root.getAttribute('data-sticky-prefix') || '';
    qsa('[data-lp-total]').forEach(function (el) { el.textContent = eur(t.price); });
    qsa('[data-lp-qty-label]').forEach(function (el) {
      el.textContent = prefix ? prefix + ' · ' + t.label : t.label;
    });
    qsa('[data-lp-save]').forEach(function (el) { el.textContent = eur(save); });
    // lp-sticky renders its note as data-paid-text; the seasonal page reuses that slot for
    // the saving rather than editing a section the Mystery Box pages depend on.
    // the bar carries the saving and, when the tier earns it, the free shipping too
    var freeFrom = parseInt(S.root.getAttribute('data-free-from'), 10) || 0;
    var shipFree = S.root.getAttribute('data-ship-free') || '';
    qsa('[data-lp-ship]').forEach(function (el) {
      var tpl = el.getAttribute('data-melo-save-text') || el.getAttribute('data-paid-text') || '';
      var bits = [];
      if (save > 0 && tpl) bits.push(tpl.replace('{amount}', eur(save)));
      if (freeFrom && shipFree && t.price >= freeFrom) bits.push(shipFree);
      var show = bits.length > 0;
      el.textContent = show ? bits.join(' · ') : '';
      // lp-sticky prints a literal "·" before this span; without hiding the whole wrapper
      // the 1-bar tier reads "7,00€ ·" with nothing after it
      if (el.parentElement && el.parentElement !== el) el.parentElement.style.display = show ? '' : 'none';
    });
  }

  /* ---- access gate -------------------------------------------------------
     The lock itself is set by the inline script in lp-melo-gate.liquid, before paint.
     This only handles the typed code and keeps the answer for the next visit. */
  function initGate() {
    var form = document.querySelector('[data-melo-gate]');
    if (!form) return;
    var want = (form.getAttribute('data-code') || '').trim().toUpperCase();

    /* belt and braces: the inline script may have unlocked from the link without the write
       landing, so whenever the page is open at this point, remember it. */
    if (!document.documentElement.classList.contains('melo-locked')) {
      try { localStorage.setItem('cdl-melo-unlocked', want); } catch (ignore) {}
    }
    var input = form.querySelector('.lp-melo-gate__input');
    var err = form.querySelector('.lp-melo-gate__err');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var got = (input.value || '').trim().toUpperCase();
      if (got && got === want) {
        try { localStorage.setItem('cdl-melo-unlocked', want); } catch (ignore) {}
        document.documentElement.classList.remove('melo-locked');
        if (err) err.hidden = true;
        window.scrollTo(0, 0);
      } else {
        if (err) err.hidden = false;
        input.focus();
        input.select();
      }
    });
    if (input && err) input.addEventListener('input', function () { err.hidden = true; });
  }

  /* ---- sign-up page: «ΕΧΕΙΣ ΗΔΗ ΚΩΔΙΚΟ» ----------------------------------
     A different job from initGate(). There is nothing to unlock on the sign-up page: it is
     a page of its own, and the lock lives on the product. So a correct code NAVIGATES.
     We write the gate's own localStorage key before leaving and also carry the code in the
     hash, because either one alone can fail — storage is refused in some private windows,
     and a hash can be dropped by a redirect. */
  function initUnlock() {
    var form = document.querySelector('[data-melo-unlock]');
    if (!form) return;
    var want = (form.getAttribute('data-code') || '').trim().toUpperCase();
    var target = (form.getAttribute('data-target') || '').trim();
    var input = form.querySelector('.lp-melo-signup__input');
    var err = form.querySelector('.lp-melo-signup__err');
    if (!input || !want || !target) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var got = (input.value || '').trim().toUpperCase();
      if (got !== want) {
        if (err) err.hidden = false;
        input.focus();
        input.select();
        return;
      }
      try { localStorage.setItem('cdl-melo-unlocked', want); } catch (ignore) {}
      window.location.href = target.indexOf('#') > -1 ? target : target + '#' + want;
    });
    if (err) input.addEventListener('input', function () { err.hidden = true; });
  }

  function onClick(e) {
    if (!e.target || typeof e.target.closest !== 'function') return;

    var tier = e.target.closest('[data-melo-tier]');
    if (tier && S.root && S.root.contains(tier)) {
      var i = S.tiers.map(function (x) { return x.el; }).indexOf(tier);
      if (i > -1) { S.i = i; paint(); }
      return;
    }

    var thumb = e.target.closest('[data-melo-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-melo-main]');
      var src = thumb.getAttribute('data-full');
      if (main && src) {
        main.setAttribute('src', src);
        main.removeAttribute('srcset');
        qsa('[data-melo-thumb]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === thumb ? 'true' : 'false');
        });
      }
      return;
    }

    var bundle = e.target.closest('[data-melo-bundle-add]');
    if (bundle) { e.preventDefault(); addBundle(bundle); return; }

    var card = e.target.closest('[data-melo-card-add]');
    if (card) {
      e.preventDefault();
      var vid = card.getAttribute('data-variant');
      if (vid) postAdd(card, [{ id: Number(vid), quantity: 1 }]);
    }
  }

  /* ---- bundle: two different variants, which lp.js's single-variant form cannot do ---- */
  function addBundle(btn) {
    var wrap = btn.closest('[data-melo-bundle]');
    if (!wrap) return;
    /* one SKU when the section has one: a single cart line at its own price, and no stray
       bar landing in the quantity ladder */
    var bundle = wrap.getAttribute('data-bundle-variant');
    if (bundle) { postAdd(btn, [{ id: Number(bundle), quantity: 1 }]); return; }
    var a = wrap.getAttribute('data-bar-variant');
    var b = wrap.getAttribute('data-melter-variant');
    var items = [];
    if (a) items.push({ id: Number(a), quantity: 1 });
    if (b) items.push({ id: Number(b), quantity: 1 });
    if (!items.length) return;
    postAdd(btn, items);
  }

  /* the one cart call this file owns, shared by the bundle band and the carousel cards.
     lp.js still owns the hero form; nothing here touches it. */
  function postAdd(btn, items) {
    var label = btn.querySelector('[data-lp-label]') || btn;
    var original = label.innerHTML;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    /* Shopify does not reliably fold a second add of the same variant into the line that is
       already in the cart, so adding the bundle on top of five bars left the drawer reading
       "MELOMAKARONO x5" and "MELOMAKARONO x1". Read the cart first: bump the line we already
       have with /cart/change.js, and only send genuinely new variants to /cart/add.js. */
    var json = function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    };

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var have = {};
        (cart.items || []).forEach(function (i) {
          /* first line wins: if the cart is already split, everything collapses onto it */
          if (!have[i.variant_id]) have[i.variant_id] = { key: i.key, quantity: i.quantity };
        });
        var fresh = [];
        var chain = Promise.resolve(null);
        items.forEach(function (it) {
          var line = have[it.id];
          if (line) {
            chain = chain.then(function () {
              return json('/cart/change.js', { id: line.key, quantity: line.quantity + it.quantity });
            });
          } else {
            fresh.push(it);
          }
        });
        if (fresh.length) {
          chain = chain.then(function () { return json('/cart/add.js', { items: fresh }); });
        }
        return chain;
      }).then(function (res) {
      if (res && res.status && res.status >= 400) throw new Error(res.description || 'add failed');
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      label.textContent = btn.getAttribute('data-lp-added-label') || 'ΠΡΟΣΤΕΘΗΚΕ';
      setTimeout(function () { label.innerHTML = original; }, 2200);
      openQuickCart();
    }).catch(function () {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      window.location.href = '/cart';
    });
  }

  function openQuickCart() {
    var hasDrawer = document.querySelector('.quick-cart');
    document.dispatchEvent(new CustomEvent('quick-cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    if (!hasDrawer) { window.location.href = '/cart'; return; }
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('quick-cart:open', { bubbles: true }));
    }, 350);
  }

  /* ---- desktop: the notes move into the buy box, under the add to cart, so the tall
     gallery column and the short buy column end together instead of leaving a gap ---- */
  var notesHome = null;
  function placeNotes() {
    var sec = document.querySelector('.lp[data-section-type="lp-melo-notes"]');
    var buy = document.querySelector('.lp-melo-buy');
    if (!sec || !buy) return;
    var inner = sec.querySelector('.lp-wrap');
    if (!inner) return;
    var desktop = window.matchMedia('(min-width: 900px)').matches;
    if (desktop && inner.parentNode !== buy) {
      if (!notesHome) { notesHome = document.createComment('lp-melo-notes-home'); inner.parentNode.insertBefore(notesHome, inner); }
      inner.classList.add('lp-melo-notes--in-buy');
      buy.appendChild(inner);
      sec.classList.add('lp-melo-notes--moved');
    } else if (!desktop && inner.parentNode === buy && notesHome && notesHome.parentNode) {
      inner.classList.remove('lp-melo-notes--in-buy');
      notesHome.parentNode.insertBefore(inner, notesHome);
      sec.classList.remove('lp-melo-notes--moved');
    }
  }

  /* ---- the more-scents carousel: the track scrolls on its own, this only adds the
     desktop arrows and keeps them honest about where the track already is ---- */
  function initMore() {
    var track = document.querySelector('[data-melo-more-track]');
    var nav = document.querySelector('[data-melo-more-nav]');
    if (!track || !nav || track.__cdlMore) return;
    track.__cdlMore = true;

    var prev = nav.querySelector('[data-melo-more-prev]');
    var next = nav.querySelector('[data-melo-more-next]');

    /* Scroll by moving a CARD into view rather than by a pixel offset. The track is
       scroll-snap-type: x mandatory, and a smooth scrollBy on a mandatory-snap container
       is snapped straight back to where it started, so the arrows did nothing. Snapping
       to an element is what mandatory snap is built for, so this survives it. */
    function cards() {
      return Array.prototype.slice.call(track.children);
    }

    /* the leftmost card still at or past the track's left edge, measured from live rects
       so the track's own padding and scroll position are already accounted for */
    function currentIndex() {
      var list = cards();
      var edge = track.getBoundingClientRect().left;
      for (var i = 0; i < list.length; i++) {
        if (list[i].getBoundingClientRect().left - edge >= -4) return i;
      }
      return list.length - 1;
    }

    function sync() {
      var overflows = track.scrollWidth - track.clientWidth > 4;
      nav.hidden = !overflows;
      if (!overflows) return;
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    /* scrollTo, not scrollIntoView: the latter also moves the PAGE when the carousel is
       off screen. The track snaps on proximity rather than mandatory, because mandatory
       snap cancels a smooth programmatic scroll and yanks the track back to where it was. */
    function go(dir) {
      var list = cards();
      if (!list.length) return;
      var i = Math.min(list.length - 1, Math.max(0, currentIndex() + dir));
      var target = track.scrollLeft + (list[i].getBoundingClientRect().left - track.getBoundingClientRect().left);
      track.scrollTo({ left: Math.max(0, Math.round(target)), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function init() {
    placeNotes();
    initMore();
    S.root = document.querySelector(ROOT);
    if (!S.root) return;
    S.unit = parseInt(S.root.getAttribute('data-unit'), 10) || 0;
    S.tiers = readTiers(S.root);
    if (!S.tiers.length) return;
    var start = parseInt(S.root.getAttribute('data-start'), 10);
    S.i = (isNaN(start) || start < 0 || start >= S.tiers.length) ? 0 : start;
    paint();
  }

  initGate();
  initUnlock();
  document.addEventListener('click', onClick);
  window.addEventListener('resize', placeNotes);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
